module.exports = __webpack_public_path__ + "img/5-4.0ed81d33.svg";